import React from "react";

type ProgressIndicatorProps = {
  total: number;
  current: number; 
  className?: string;
};

function clamp(value: number, min: number, max: number) {
  return Math.min(Math.max(value, min), max);
}

const ProgressIndicator: React.FC<ProgressIndicatorProps> = ({
  total,
  current,
  className,
}) => {
  const safeTotal = Math.max(0, Math.floor(total));
  const safeCurrent = clamp(Math.floor(current), 0, Math.max(0, safeTotal - 1));
  const ids = React.useMemo(() => Array.from({ length: safeTotal }, (_, idx) => `pi-${safeTotal}-${idx}`), [safeTotal]);

  return (
    <div className={`flex items-center justify-center py-2 ${className ?? ""}`}>
      {ids.map((id, i) => (
        <div
          key={id}
          className={`h-2 rounded-md mx-1 ${
            i === safeCurrent ? "w-6 bg-primary" : "w-2 bg-input-bg"
          }`}
        />
      ))}
    </div>
  );
};

export default ProgressIndicator;


